import React from 'react'
import './TreeView.scss'
import { Lexicon } from '@nitidbit/lexicon'
import lexiconRaw from './ClinicDetailsStrings.json'

const TreeView = ({
  parentKey,
  allOfferings,
  clinicOfferings,
  childrenLookupTable,
  depth = 0,
  locale,
}) => {
  const hasIcon = depth === 1
  const depthClass = `depth-${depth}`
  const lexicon = new Lexicon(
    lexiconRaw,
    locale,
    'bedsider/app/javascript/components/ClinicDetails/ClinicDetailsStrings.json'
  )
  const link = lexicon.get(`non_abortion_services.bc_links.${parentKey}`)

  const stiTestingKeys = [
    'chlamydia_testing',
    'gonorrhea_testing',
    'herpes_testing',
    'hiv_testing',
    'sti_testing',
    'syphilis_testing',
  ]

  return (
    <ul className={`TreeView ${depthClass}`}>
      {depth > 0 && (
        <li className={`treeview-list-item ${depthClass}`}>
          <span className="icon-and-name">
            {hasIcon && <img src={allOfferings[parentKey]['icon']} alt="" />}
            {stiTestingKeys.some((stiTesting) =>
              parentKey.includes(stiTesting)
            ) ? (
              allOfferings[parentKey][`name_${locale}`]
            ) : (
              <a href={link}>{allOfferings[parentKey][`name_${locale}`]}</a>
            )}
          </span>
        </li>
      )}
      {childrenLookupTable[parentKey] &&
        childrenLookupTable[parentKey].map(
          (childKey) =>
            clinicOfferings.includes(childKey) && (
              <TreeView
                key={childKey}
                parentKey={childKey}
                childrenLookupTable={childrenLookupTable}
                allOfferings={allOfferings}
                clinicOfferings={clinicOfferings}
                depth={depth + 1}
                locale={locale}
              />
            )
        )}
    </ul>
  )
}

export default TreeView
